import { AppBox, AppButton, AppPaper, AppText, AppTitle } from "../../../../../commons/components";
import AppBorderBox from "../../../../../commons/components/BorderBox";
import IconEmpty from "../../../../../commons/components/icons/empty";
import { SeasonStatusEnum } from "../../../../../commons/enums/season-status-enum";
import {
  IFootballCompetition,
  IFootballHostedCompetition,
} from "../../../../../commons/models/football/interface/i-football-competition";
import ability from "../../../../../casl/Can";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { FootballMatchDetail } from "../../../../../commons/models/football/football-match-detail";
import { useAppSelector } from "../../../../../hooks/app";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";
import { ManageFootballCompetition } from "../../../../../commons/models/football/admin/manage-football-competition";

interface EmptyGroupComponentProps {
  isPastSeason?: boolean;
  onAddClick?: () => void;
}

export const EmptyGroupComponent = ({ onAddClick, isPastSeason }: EmptyGroupComponentProps) => {
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);
  return (
    <AppPaper shadow="xs">
      <AppBorderBox borderVariant="dashed" p="sm">
        <AppBox alignItems="center" flexDirection="column" justifyContent="center" gap="2xs">
          <IconEmpty width={56} height={56} color="rgba(var(--border-200))" />
          {ability.can(
            RolePolicyActionEnum.UPDATE,
            new ManageFootballTeam((fetchedCompetition as IFootballHostedCompetition).hostTeam)
          ) || ability.can(RolePolicyActionEnum.UPDATE, new ManageFootballCompetition(fetchedCompetition)) ? (
            <>
              <AppTitle as="h6">No groups created</AppTitle>
              {isPastSeason || (
                <>
                  {fetchedCompetition.latestSeason &&
                  fetchedCompetition.latestSeason.status === SeasonStatusEnum.Active ? (
                    <AppText fontWeight="semibold">You need to add a group to continue ahead.</AppText>
                  ) : (
                    <AppText fontWeight="semibold">
                      To add group, you need to start the season first. Click the "Start Season" button above to begin.
                    </AppText>
                  )}
                  <AppBox displayBlock mt={"xs"}>
                    <AppButton
                      label="Add Group"
                      onClick={onAddClick}
                      disabled={
                        !(
                          fetchedCompetition.latestSeason &&
                          fetchedCompetition.latestSeason.status === SeasonStatusEnum.Active
                        )
                      }
                    />
                  </AppBox>
                </>
              )}
            </>
          ) : (
            <AppTitle as="h6">No group found</AppTitle>
          )}
        </AppBox>
      </AppBorderBox>
    </AppPaper>
  );
};
